import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ImageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getProp from "@insite/mobius/utilities/getProp";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    product: ProductModel;
    image: ImageModel;
    useLargeImage?: boolean;
    onClick?: () => void;
    extendedStyles?: NISProductPrimaryImageStyles;
    id: string;
    isPopUp?: boolean;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

export interface NISProductPrimaryImageStyles {
    centeringWrapper?: InjectableCss;
    /**
     * @deprecated Not used anymore
     */
    hiddenWrapper?: InjectableCss;
    /**
     * @deprecated Not used anymore
     */
    spinner?: LoadingSpinnerProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
    productDisclaimerMsg?: InjectableCss;
    message?: TypographyProps;
    productImageWrapper?: InjectableCss;
    buttonWrapper?: InjectableCss;
    buttonComapre?: InjectableCss;
    shareButton?: InjectableCss;
    printButton?: InjectableCss;
}

export const nisProductPrimaryImageStyles: NISProductPrimaryImageStyles = {
    shareButton: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
        `,
    },
    centeringWrapper: {
        css: css`
            min-height: 350px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            padding: 0 40px;
            img {
                max-width: 399px !important;
                height: auto !important;
                aspect-ratio: 1/1;
                object-fit: contain;
                max-height: 399px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px !important;
                        img {
                            max-width: 343px !important;
                        }
                    `,
                    css`
                        padding: 0px !important;
                        img {
                            max-width: 343px !important;
                        }
                    `,
                    css`
                        padding: 0px !important;
                        img {
                            max-width: 297px !important;
                            height: auto !important;
                            max-height: 297px !important;
                        }
                    `,
                    css`
                        margin-top: -15px;
                        padding: 24px 40px 0 66px !important;
                    `,
                    css`
                        margin-top: -15px;
                        padding: 24px 40px 0 66px !important;
                    `,
                ])}
            @media (min-width: 992px) and (max-width: 1280px) {
                padding: 0px !important;
                margin: 0px !important;
            }
            @media (min-width: 1799px) {
                padding: 0px !important;
            }
        `,
    },
    productImageWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            background: ${COLORS.white};
            box-shadow:
                0px 0px 1px rgba(38, 37, 37, 0.56),
                0px 2px 8px rgba(38, 37, 37, 0.16);
            padding: 10px;
            width: 100%;
            height: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        height: 100%;
                    `,
                    css`
                        width: 100%;
                        height: 100%;
                    `,
                    null,
                    css`
                        width: 399px;
                        height: 399px;
                    `,
                    null,
                ])}
            @media (min-width: 992px) and (max-width: 1180px) {
                width: 100%;
                height: 350px;
            }
            @media (min-width: 1799px) {
                width: 100% !important;
                height: 100% !important;
            }
        `,
    },
    image: {
        css: css`
            margin: auto;
            cursor: pointer;
        `,
    },
    img: {
        css: css`
            cursor: pointer;
        `,
    },
    productDisclaimerMsg: {
        css: css`
            margin-top: 8px;
            width: 100%;
            line-height: 16px;
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        margin-top: 8px;
                    `,
                    css`
                        width: 399px;
                    `,
                    null,
                ])}
            @media (min-width: 992px) and (max-width: 1180px) {
                width: 100%;
            }
        `,
    },
    message: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.baseBold};
            font-size: ${TYPOGRAPHY.size.tiny};
            color: #838b90;
            line-height: ${TYPOGRAPHY.size.base};
            font-family: Roboto;
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;

            justify-content: start;
            gap: 32px;
            margin-top: 8px;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        // margin-top: 8px;
                    `,
                    css`
                        width: 399px;
                    `,
                    null,
                ])}
            @media (min-width: 992px) and (max-width: 1180px) {
                width: 100%;
            }
        `,
    },
};

const NISProductPrimaryImage = ({
    productSettings,
    product,
    image,
    useLargeImage,
    onClick,
    extendedStyles,
    id,
    isPopUp,
}: Props) => {
    const [styles] = useState(() => mergeToNew(nisProductPrimaryImageStyles, extendedStyles));

    if (!product) {
        return null;
    }

    useEffect(() => {
        if ((window as any).sirvScriptAdded) {
            return;
        }

        if (
            productSettings.imageProvider !== "SIRV" ||
            !product.images ||
            product.images.every(o => o.imageType !== "360")
        ) {
            return;
        }

        const script = document.createElement("script");
        script.src = "https://scripts.sirv.com/sirv.js";
        script.async = true;

        document.body.appendChild(script);
        (window as any).sirvScriptAdded = true;
    }, [productSettings.imageProvider, product]);

    const imageWrapperClickHandler = () => {
        onClick?.();
    };

    const imageWrapperKeyHandler: React.KeyboardEventHandler<HTMLImageElement> = event => {
        event.preventDefault();
        event.stopPropagation();
        if (event.key === "Enter") {
            onClick?.();
        }
    };

    const path = useLargeImage
        ? image.largeImagePath || image.mediumImagePath
        : image.mediumImagePath || image.largeImagePath;
    if (!path) {
        return null;
    }

    return (
        <>
            {image.imageType === "Static" && (
                <>
                    <StyledWrapper data-test-selector="ProductDetails_mainImage_wrapper" {...styles.centeringWrapper}>
                        <StyledWrapper {...styles.productImageWrapper} onClick={imageWrapperClickHandler}>
                            <Img
                                {...styles.img}
                                src={path}
                                altText={image?.imageAltText ? image?.imageAltText : product?.productTitle}
                                loading="eager"
                                data-test-selector="productDetails_mainImage"
                                onKeyPress={imageWrapperKeyHandler}
                                tabIndex={0}
                                width="100%"
                                height="399px"
                            />
                        </StyledWrapper>
                        {!isPopUp && (
                            <StyledWrapper data-selector="ProductDeatils_Buttons" {...styles.buttonWrapper}>
                                <StyledWrapper {...styles.shareButton}>
                                    <Zone contentId={id} zoneName="nis_pdp_buttons_addToList"></Zone>
                                </StyledWrapper>
                                <StyledWrapper {...styles.shareButton}>
                                    <Zone contentId={id} zoneName="nis_pdp_buttons_share"></Zone>
                                </StyledWrapper>
                                <StyledWrapper {...styles.printButton}>
                                    <Zone contentId={id} zoneName="nis_pdp_buttons_print"></Zone>
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                        <StyledWrapper
                            data-test-selector="ProductDetails_mainImage_Description"
                            {...styles.productDisclaimerMsg}
                        >
                            <Typography {...styles.message}>{siteMessage("nisco_pdpImageDisclaimer")}</Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </>
            )}
            {image.imageType === "360" && productSettings.imageProvider === "SIRV" && (
                <div style={{ minHeight: 300 }} onClick={imageWrapperClickHandler}>
                    <div className="Sirv" key={image.id} data-src={image.mediumImagePath} />
                </div>
            )}
        </>
    );
};

export default connect(mapStateToProps)(NISProductPrimaryImage);
